
import React from "react";

interface FeatureHighlightProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const FeatureHighlight: React.FC<FeatureHighlightProps> = ({
  icon,
  title,
  description,
}) => {
  return (
    <div className="flex gap-4">
      <div className="shrink-0 h-10 w-10 rounded-full bg-sauna-blue/10 flex items-center justify-center text-sauna-blue">
        {icon}
      </div>
      <div>
        <h4 className="font-medium text-sauna-navy">{title}</h4>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );
};

export default FeatureHighlight;
